const C = require("../constants");

const dynamicTableList = (data) => {
    return {
        type: C.DYNAMIC_TABLE_LIST,
        data
    }
};

const dynamicTableAddOrUpdate = (data) => {
    return {
        type: C.DYNAMIC_TABLE_LIST_ADD_OR_UPDATE,
        data
    }
};

const dynamicTableDelete = (data) => {
    return {
        type: C.DYNAMIC_TABLE_LIST_DELETE,
        data
    }
};

export {
    dynamicTableList,
    dynamicTableDelete,
    dynamicTableAddOrUpdate
};


// WEBPACK FOOTER //
// ./src/actions/DynamicTableDataAction.js